import { AuditLog } from "modules/auditLog";

const ActivityLogPage = () => {
  return <AuditLog />;
};

export default ActivityLogPage;
